import { render } from "./Tickets.vue?vue&type=template&id=25a29acc&scoped=true&ts=true"
import script from "./Tickets.vue?vue&type=script&lang=ts"
export * from "./Tickets.vue?vue&type=script&lang=ts"

import "./Tickets.vue?vue&type=style&index=0&id=25a29acc&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_jecko_1768814729495645082/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a29acc"]])

export default __exports__